<div class="container mx-auto md:border md:bg-white/80 md:p-4 md:shadow-sm">
  <ng-content></ng-content>
</div>
